import React from "react";
import { Row, Col, Button } from "react-bootstrap";
import "../assets/css/footer.css"; // Assuming you want to add custom styles in this file
import telegramIcon from "../assets/images/Telegram.png";
import whatsappIcon from "../assets/images/Whatsapp.png";
import mailIcon from "../assets/images/Mail.png";
import logo_color from "../assets/images/logo_color.png";
import logo_platform from "../assets/images/logo_platform.png";

const Footer = () => {
  return (
    <div className="container-fluid footer-container">
      {/* First Section */}
      <Row className="footer-first-section">
        {/* First Part */}
        <Col xs={12} md={6} className="footer-first-part">
          <Row>
            {/* Global Headquarters */}
            <Row>
              <Col xs={12} md={4} className="footer-section">
                <span className="footer-first-section-title">
                  Global Headquarters
                </span>
                <ul>
                  <li className="content-txt">Ost Infinity</li>
                  <li className="content-txt">Taunusanlage 9-10</li>
                  <li className="content-txt">60239 Frankfurt am Main</li>
                  <li className="content-txt">Hessen</li>
                  <li className="content-txt">Germany</li>
                </ul>
              </Col>

              {/* Contact */}
              <Col xs={12} md={4} className="footer-section">
                <span className="footer-first-section-title">Contact</span>
                <div className="contact-container">
                  <div className="contact-item">
                    <img src={telegramIcon} alt="Telegram Icon" />
                    <span className="content-txt">Telegram</span>
                  </div>
                  <div className="contact-item">
                    <img src={mailIcon} alt="Zalo Icon" />
                    <span className="content-txt">Zalo</span>
                  </div>
                  <div className="contact-item">
                    <img src={whatsappIcon} alt="WeChat Icon" />
                    <span className="content-txt">WeChat</span>
                  </div>
                  <div className="contact-item">
                    <img src={mailIcon} alt="Mail Icon" />
                    <span className="content-txt">sales@ostinfinity.net</span>
                  </div>
                </div>
              </Col>

              {/* Resources */}
              <Col xs={12} md={4} className="footer-section">
                <span className="footer-first-section-title">Resources</span>
                <ul>
                  <li className="content-txt">Careers</li>
                </ul>
              </Col>
            </Row>
          </Row>
          <Row>
            <img src={logo_color} alt="logo_color" className="logo_color"/><span>ST</span><span>INFINITY</span>
            <span>Identity-First Platforms</span>
          </Row>
        </Col>

        {/* Second Part - Logo Image */}
        <Col xs={12} md={6} className="footer-logo">
          <img
            src="https://via.placeholder.com/150" // Replace with your logo image URL
            alt="Logo"
            className="footer-logo-img"
          />
        </Col>
      </Row>

      {/* Second Section */}
      <Row className="footer-second-section">
        {/* First Part - Text */}
        <Col xs={12} md={4} className="footer-text">
          <p>
            ViXa platform enables businesses to manage cybersecurity and data
            protection in an efficient, scalable way. Explore our tools and
            resources for a secure future.
          </p>
        </Col>

        {/* Second Part - Links (Privacy & Terms) */}
        <Col xs={12} md={4} className="footer-links">
          <h6>Policies</h6>
          <ul>
            <li>
              <a href="/privacy-policy">Privacy & Cookie Policy</a>
            </li>
            <li>
              <a href="/terms-of-use">Terms of Use</a>
            </li>
            <li>
              <a href="/human-rights">Ost Infinity Human Rights Statement</a>
            </li>
          </ul>
        </Col>

        {/* Third Part - Image Links */}
        <Col xs={12} md={4} className="footer-image-links">
          <h6>Follow Us</h6>
          <Row>
            <Col xs={4}>
              <a href="https://www.facebook.com">
                <img
                  src="https://via.placeholder.com/30"
                  alt="Facebook"
                  className="footer-icon"
                />
              </a>
            </Col>
            <Col xs={4}>
              <a href="https://www.twitter.com">
                <img
                  src="https://via.placeholder.com/30"
                  alt="Twitter"
                  className="footer-icon"
                />
              </a>
            </Col>
            <Col xs={4}>
              <a href="https://www.linkedin.com">
                <img
                  src="https://via.placeholder.com/30"
                  alt="LinkedIn"
                  className="footer-icon"
                />
              </a>
            </Col>
          </Row>
        </Col>
      </Row>
    </div>
  );
};

export default Footer;
